"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Icon, Typography } from "@bookips/sds";
import { useState } from "react";
const defaultSortOptions = [
    {
        value: "popular",
        label: "인기순"
    },
    {
        value: "latest",
        label: "최신순"
    },
    {
        value: "unit",
        label: "단원순"
    }
];
/**
 * 상품 리스트 헤더 컴포넌트
 * - 총 개수 표시
 * - 정렬 드롭다운
 */ export const ProductListHeader = (param)=>{
    let { className , totalCount , sortOptions , selectedSort , onSortChange , fixedSortLabel , pageType ="edition"  } = param;
    const [isOpen, setIsOpen] = useState(false);
    // sortOptions가 없거나 빈 배열이면 기본 옵션 사용
    const options = sortOptions && sortOptions.length > 0 ? sortOptions : defaultSortOptions;
    const currentOption = options.find((opt)=>opt.value === selectedSort) || options[0];
    // 페이지 타입별 Position 값
    const position = pageType === "system" ? "System Category" : "Edition Category Product List";
    const handleSelect = (value)=>{
        // MX-360/MX-366: 정렬 옵션 선택 이벤트
        const selectedOption = options.find((opt)=>opt.value === value);
        mixpanelEvent("Sorting Clicked", {
            ...pageType === "system" ? {
                "Sorting Type": (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || value
            } : {
                "Button Name": (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || value,
                Value: value
            },
            Position: position
        });
        onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(value);
        setIsOpen(false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex items-center justify-between py-2", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-0.5",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-secondary",
                        children: "총"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-secondary",
                        children: totalCount.toLocaleString()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-secondary",
                        children: "개"
                    })
                ]
            }),
            fixedSortLabel ? /*#__PURE__*/ _jsx(Typography, {
                variant: "body2",
                className: "text-secondary",
                children: fixedSortLabel
            }) : /*#__PURE__*/ _jsxs("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        type: "button",
                        onClick: ()=>setIsOpen(!isOpen),
                        className: "flex items-center gap-1 text-secondary",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                children: currentOption.label
                            }),
                            /*#__PURE__*/ _jsx(Icon.ArrowDown_1px, {
                                className: cn("size-3.5 text-secondary transition-transform", isOpen && "rotate-180")
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fixed inset-0 z-10",
                                onClick: ()=>setIsOpen(false)
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "absolute right-0 top-full z-20 mt-1 min-w-[100px] overflow-hidden rounded-md bg-white py-2 shadow-[0px_2px_8px_0px_rgba(0,0,0,0.08),0px_1px_4px_0px_rgba(0,0,0,0.04)]",
                                children: options.map((option)=>{
                                    const isSelected = option.value === currentOption.value;
                                    return /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        onClick: ()=>handleSelect(option.value),
                                        className: cn("w-full px-3 py-2 text-left hover:bg-indigo-0", isSelected && "bg-indigo-0"),
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            variant: "body2",
                                            className: cn(isSelected ? "text-primary-main" : "text-primary"),
                                            children: option.label
                                        })
                                    }, option.value);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
